import { post, get } from "../../../common/api-service";
import { IDealershipUserInvite } from "../interfaces/IDealershipUser";

const DealershipUserAPI = {
    async GetAll() {
        const url = `/dealership/user/get-all`;
        return await get(url);
    },

    async GetDealershipUrl() {
        const url = `/dealer/get-dealership-url`;
        return await get(url);
    },

    async GetDealershipUrlById(dealershipId: string) {
        const url = `/dealer/get-url/${dealershipId}`;
        return await get(url);
    },

    async DealershipUserInvitation(
        dealershipUserInvite: IDealershipUserInvite
    ) {
        const url = `/dealership/user/invitation`;
        return await post(url, dealershipUserInvite);
    },

    async SetDealershipUserStatus(dealershipUser: {
        userGuid: string;
        status: string;
        email?: string;
    }) {
        const url = `/dealership/user/set-status`;
        return await post(url, dealershipUser);
    },

    async DealershipUserReInvite(dealershipUserInvite: IDealershipUserInvite) {
        const url = `/dealership/user/resend-invitation`;
        return await post(url, dealershipUserInvite);
    },
};

export default DealershipUserAPI;
